export type ScheduleFormValue = {
  interval: string;
  cron: string;
  enabled: boolean;
  name?: string;
};

export type CrawlerFormData = {
  url: string;
  linkDepth: number;
  includePath: string;
  excludePath: string;
  callbackUrl: string;
  maxCost: string;
  schedule: ScheduleFormValue;
  notification: string;
  outputFormat: string | undefined;
  autoparse: boolean | undefined;
  disableRedirects: boolean;
  retry404: boolean;
  renderJs: boolean;
  useOwnHeaders: boolean;
  advancedBypassing: boolean;
  residentialIps: boolean;
  sessionNumber: number | undefined;
  countryCode: string;
  deviceType: string;
};

export const DEFAULT_CRAWLER_FORM_VALUES: CrawlerFormData = {
  url: "",
  linkDepth: 2,
  includePath: ".*",
  excludePath: "",
  callbackUrl: "",
  maxCost: "1000",
  schedule: {
    interval: "daily",
    cron: "0 0 * * *",
    enabled: true,
    name: "",
  },
  notification: "never",
  outputFormat: undefined,
  autoparse: undefined,
  disableRedirects: false,
  retry404: false,
  renderJs: false,
  useOwnHeaders: false,
  advancedBypassing: false,
  residentialIps: false,
  sessionNumber: undefined,
  countryCode: "US",
  deviceType: "Desktop",
};
